import React, { useRef, useState, useEffect } from 'react'
import tw from 'twin.macro'
import { css } from '@emotion/react'
import Flickity from 'react-flickity-component'
import { FlickityControls, FlickityCircularPrevNextButtons } from './Controls'

const isSSR = typeof window === 'undefined'

const Carousel = ({
  data,
  ItemComponent,
  initialIndexSmall = 0,
  initialIndexLarge = 0,
  cellAlign = 'center',
  controls,
}) => {
  const isLargeWindow = isSSR ? true : window.innerWidth >= 1080
  const carousel = useRef(null)
  const [activeDotIndex, setActiveDotIndex] = useState(0)
  const [flickitySettled, setFlickitySettled] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      carousel.current.flkty.resize()
    }, 30)
  }, [flickitySettled])

  useEffect(() => {
    if (carousel.current) {
      carousel.current.flkty.on('change', (e) => {
        setActiveDotIndex(e)
      })

      carousel.current.flkty.on('ready', () => {
        setFlickitySettled(true)
      })
    }
  }, [])

  const prevSlide = () => {
    carousel.current.flkty.previous()
  }

  const nextSlide = () => {
    carousel.current.flkty.next()
  }

  return (
    <>
      {data && (
        <div tw="relative">
          <Flickity
            className="carousel"
            css={[
              flickitySettled &&
                css`
                  .flickity-slider {
                    height: 100%;
                  }
                `,
              tw`relative overflow-x-hidden`,
            ]}
            ref={carousel}
            options={{
              prevNextButtons: false,
              pageDots: false,
              resize: true,
              initialIndex: isLargeWindow
                ? initialIndexLarge
                : initialIndexSmall,
              wrapAround: data.length >= 3,
              adaptiveHeight: false,
              setGallerySize: true,
              cellAlign,
            }}
            static
          >
            {data.map((item, index) => (
              <ItemComponent key={index} index={index} {...item} />
            ))}
          </Flickity>

          {controls === 'regular' && (
            <FlickityControls
              prevSlide={prevSlide}
              nextSlide={nextSlide}
              dotCount={data.length}
              activeDotIndex={activeDotIndex}
            />
          )}
          {controls === 'circular' && (
            <FlickityCircularPrevNextButtons
              prevSlide={prevSlide}
              nextSlide={nextSlide}
              dotCount={data.length}
              activeDotIndex={activeDotIndex}
            />
          )}
        </div>
      )}
    </>
  )
}

export default Carousel
